import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useGetDirectNodeNum - 获取用户直推人数（注册就算直推）
 */
const useGetDirectNodeNum = () => {
    const { address, contractEvm: { QueryFunction } } = useConnectWallet();

    // 直推总数
    const [directNodeNum, setDirectNodeNum] = useState<bigint>(BigInt(0));
    // loading
    const [directNodeNumLod, setLoading] = useState(false);

    /**
     * getDirectNodeNum - 获取用户直推人数
     */
    const getDirectNodeNum = useCallback(async () => {
        if (!QueryFunction || !address) return;

        try {
            setLoading(true);
            const res = await QueryFunction.getDirectNodeNum(address);
            setDirectNodeNum(res);

            return res;
        } catch (error) {
            console.log('useGetDirectNodeNum error:', error);
        } finally {
            setLoading(false);
        }
    }, [QueryFunction, address]);

    useEffect(() => {
        getDirectNodeNum();
    }, [getDirectNodeNum]);

    return {
        directNodeNum,
        directNodeNumLod,
        getDirectNodeNum
    };
};

export default useGetDirectNodeNum;
